/* global axios */
import ApiClient from './ApiClient';

class TicketsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  create(data) {
    const pipelineId = data.ticket?.pipeline_id || data.pipeline_id;
    return axios.post(
      `${this.baseUrl()}/pipelines/${pipelineId}/tickets`,
      data
    );
  }

  show(id) {
    return axios.get(`${this.baseUrl()}/tickets/${id}`);
  }

  getByPipeline(pipelineId, params = {}) {
    return axios.get(`${this.baseUrl()}/pipelines/${pipelineId}/tickets`, {
      params,
    });
  }

  update(pipelineId, ticketId, data) {
    return axios.patch(
      `${this.baseUrl()}/pipelines/${pipelineId}/tickets/${ticketId}`,
      data
    );
  }

  destroy(pipelineId, ticketId) {
    return axios.delete(
      `${this.baseUrl()}/pipelines/${pipelineId}/tickets/${ticketId}`
    );
  }

  moveStage(pipelineId, ticketId, data) {
    return axios.post(
      `${this.baseUrl()}/pipelines/${pipelineId}/tickets/${ticketId}/move_stage`,
      data
    );
  }

  changeStatus(pipelineId, ticketId, data) {
    return axios.post(
      `${this.baseUrl()}/pipelines/${pipelineId}/tickets/${ticketId}/change_status`,
      data
    );
  }

  assignAgent(pipelineId, ticketId, agentId) {
    return axios.post(
      `${this.baseUrl()}/pipelines/${pipelineId}/tickets/${ticketId}/assign_agent`,
      { agent_id: agentId }
    );
  }

  removeAgent(pipelineId, ticketId, agentId) {
    return axios.delete(
      `${this.baseUrl()}/pipelines/${pipelineId}/tickets/${ticketId}/remove_agent`,
      { data: { agent_id: agentId } }
    );
  }
}

export default new TicketsAPI();
